export interface IClaimCount {
  icon?: JSX.Element;
  valueComponent?: JSX.Element;
  labelComponent?: JSX.Element;
  containerClass?: string;
  leftBarColor?: string;
  iconClass?: string;
}

export default function ClaimCount({
  icon,
  valueComponent,
  labelComponent,
  containerClass = "",
  leftBarColor = "",
  iconClass = "",
}: IClaimCount) {
  return (
    <div
      className={`relative rounded-lg ${containerClass} py-2 px-4 gap-2 flex  rounded-lg ring-1 ring-gray/30 shadow-lg shadow-offWhite `}
    >
      <section className={`${leftBarColor} h-15 w-1 rounded-lg`} />
      <section className="flex flex-col min-w-[70%]">
        <span className="text-sm text-body font-bold">{labelComponent}</span>
        <span className="font-extrabold text-md text-body pt-2">
          {" "}
          {valueComponent}
        </span>
      </section>
      <section className={`w-7 ml-5 stroke-current  ${iconClass}`}>
        {icon}
      </section>
    </div>
  );
}
